module.exports = __webpack_public_path__ + "static/media/Asusena_RDA.ab5f13b9.png";